import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchAmazingTeam(params) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "get",
    params
  });
}

export async function createAmazingTeam(data) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "post",
    data
  });
}

export async function updateAmazingTeam(id, data) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "post",
    data
  });
}

export async function fetchById(id) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "get",
  });
}

export async function fetchAwards(params) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "get",
    params
  });
}

export async function createAwards(data) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "post",
    data
  });
}

export async function updateAwards(id, data) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "post",
    data
  });
}

export async function remove(id) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "delete",
  });
}

// People in charge
export async function fetchIntroduce(params) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "get",
    params
  });
}

export async function createIntroduce(id, data) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "post",
    data
  });
}

export async function updateIntroduce(id, data) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "post",
    data
  });
}

export async function fetchPeople(params) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "get",
    params
  });
}

export async function createPeopleInCharge(data) {
  return await request({
    url: ENDPOINT.ABOUT_US,
    method: "post",
    data
  });
}

export async function updatePeopleInCharge(id, data) {
  return await request({
    url: `${ENDPOINT.ABOUT_US}/${id}`,
    method: "post",
    data
  });
}

export async function removeFile(id) {
  return await request({
    url: `${ENDPOINT.ABOUT_US_DELETE_FILE}/${id}`,
    method: "post",
  });
}